<template>
  <loader v-if="isLoadingStatus" />
  <div v-else>
    <template v-if="reservation.StatusIds && showIdsReservationStatus">
      <h2>{{ i18n.t('/StockDashboard/ReservationStatus/TitleIDS') }}</h2>
      <dl>
        <dt>{{ i18n.t('/StockDashboard/ReservationStatus/Status') }}</dt>
        <dd>{{ reservedStateIds }}</dd>
        <dt>{{ i18n.t('/StockDashboard/ReservationStatus/IDS/EndDate') }}</dt>
        <dd>{{ formatDate(reservation.StatusIds.ExpiresAt) }}</dd>
        <dt>{{ i18n.t('/StockDashboard/ReservationStatus/IDS/Dealer') }}</dt>
        <dd>
          <loader v-if="isLoadingDealerIDS" />
          <span v-else>{{ dealerNameIDS }}</span>
        </dd>
        <dt>{{ i18n.t('/StockDashboard/ReservationStatus/LogisticInfo') }}</dt>
        <dd>{{ reservation.StatusIds.LogisticStatus }}</dd>

        <dt>
          {{ i18n.t('/StockDashboard/ReservationStatus/IDS/StatusMessage') }}
        </dt>
        <dd>{{ reservation.StatusIds.StatusMessage }}</dd>
      </dl>
    </template>

    <template v-if="reservation.StatusSyntec">
      <h2>{{ i18n.t('/StockDashboard/ReservationStatus/TitleSyntec') }}</h2>
      <dl>
        <dt>{{ i18n.t('/StockDashboard/ReservationStatus/CarLocation') }}</dt>
        <dd>{{ reservation.StatusSyntec.LocationDealer }}</dd>
        <dt>{{ i18n.t('/StockDashboard/ReservationStatus/Establishment') }}</dt>
        <dd>{{ reservation.StatusSyntec.Establishment }}</dd>
        <dt>{{ i18n.t('/StockDashboard/ReservationStatus/Reserved') }}</dt>
        <dd>
          {{
            reservation.StatusSyntec.Reserved
              ? i18n.t('/StockDashboard/ReservationStatus/ReservedYes')
              : i18n.t('/StockDashboard/ReservationStatus/ReservedNo')
          }}
        </dd>

        <dt>
          {{ i18n.t('/StockDashboard/ReservationStatus/SoldSubjectToFinancing') }}
        </dt>
        <dd>
          {{
            reservation.StatusSyntec.SoldSubjectToFinancing
              ? i18n.t('/StockDashboard/ReservationStatus/SoldSubjectToFinancingYes')
              : i18n.t('/StockDashboard/ReservationStatus/SoldSubjectToFinancingNo')
          }}
          <!-- TODO fix this: it is not mapped anymore in backend code  -->
          <span v-if="reservation.StatusSyntec.SoldSubjectToFinancingExpiresAt">
            ({{ i18n.t('/StockDashboard/ReservationStatus/EndDate') }}
            {{ reservation.StatusSyntec.SoldSubjectToFinancingExpiresAt }})
          </span>
        </dd>
        <dt>{{ i18n.t('/StockDashboard/ReservationStatus/EndDate') }}</dt>
        <dd>{{ formatDate(reservation.StatusSyntec.ExpiresAt) }}</dd>
      </dl>
    </template>

    <h2>{{ i18n.t('/StockDashboard/ReservationStatus/TitleCST') }}</h2>
    <template v-if="reserveOwnStockCarResponseMessage">
      <dl>
        <dt>
          {{ i18n.t('/StockDashboard/ReservationStatus/OwnStockCarReservedTitle') }}
        </dt>
        <dd>{{ reserveOwnStockCarResponseMessage }}</dd>
      </dl>
    </template>
    <table>
      <thead>
        <tr>
          <th>{{ i18n.t('/StockDashboard/ReservationStatus/Status') }}</th>
          <th>{{ i18n.t('/StockDashboard/ReservationStatus/QuoteId') }}</th>
          <th>
            {{ i18n.t('/StockDashboard/ReservationStatus/Establishment') }}
          </th>
          <th>
            {{ i18n.t('/StockDashboard/ReservationStatus/DeliveryDate') }}
          </th>
          <th>
            {{ i18n.t('/StockDashboard/ReservationStatus/ExpireDate') }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(cstStatus, i) in reservation.Quotes" :key="i">
          <td>{{ cstStatus.Status }}</td>
          <td>{{ cstStatus.QuoteId }}</td>
          <td>{{ cstStatus.EstablishmentID }}</td>
          <td>{{ formatDate(cstStatus.DeliveryDate) }}</td>
          <td>{{ formatDate(cstStatus.ExpireDate) }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import Loader from '@/components/generic/presentational/atoms/loader/Loader.vue'
import Configuration_Api from '@/api/server/Configuration'
import StockCarsApi from '@/api/server/StockCars'
import moment from 'moment'
import { mapState, mapGetters } from 'vuex'

export default {
  components: {
    Loader,
  },
  props: {
    stockCarId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      dealerIDS: {},
      isLoadingDealerIDS: false,
      isLoadingStatus: false,
      dealerSyntec: {},
      userInfo: window.info.user.UserInfo,
      lastUpdatedBy: '',
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      reservation: {},
      stockCar: {},
    }
  },
  computed: {
    ...mapState('user', ['dealerId']),
    ...mapGetters({
      dealerSettings: 'user/dealerSettings',
    }),
    reservedState() {
      if (this.reservation.ReservationStatus === 'NOT_AVAILABLE') {
        return this.i18n.t('/StockDashboard/ReservationStatus/NotAvailable')
      }
      return this.i18n.t('/StockDashboard/ReservationStatus/Available')
    },
    reservedStateIds() {
      if (this.reservation.StatusIds?.Status === 'NOT_AVAILABLE') {
        return this.i18n.t('/StockDashboard/ReservationStatus/NotAvailable')
      }
      return this.i18n.t('/StockDashboard/ReservationStatus/Available')
    },
    dealerNameIDS() {
      return this.dealerIDS?.Name != null
        ? this.dealerIDS.Name
        : this.i18n.t('/StockDashboard/ReservationStatus/DealerUnknown')
    },
    reservedByOwnDealer() {
      return this.reservation?.StatusIds?.DealerId == this.userInfo.DealerId
    },
    showIdsReservationStatus() {
      return this.i18n.t('/StockDashboard/ReservationStatus/ShowIdsReservationStatus') == 'true'
    },
    reserveOwnStockCarResponseMessage() {
      let responseBody = this.stockCar?.ClaimDetails
      if (!responseBody) return null
      if (responseBody?.ClaimDealerId != this.dealerId) return null

      let claimPeriodEndDate = moment.utc(responseBody.ClaimPeriodEndDate, 'YYYY-MM-DD')
      if (claimPeriodEndDate.isBefore(moment.utc(), 'day')) return null

      let messageTemplate = this.i18n.t(
        '/StockDashboard/ReservationStatus/OwnStockCarReservedMessage',
        {
          date: claimPeriodEndDate.format('DD-MM-YYYY'),
          establishment: responseBody.ClaimEstablishment,
          user: responseBody.SalesEmail,
        }
      )

      return messageTemplate
    },
  },
  async mounted() {
    this.isLoadingStatus = true
    this.reservation = await StockCarsApi.getReservationInfo(this.stockCarId)

    if (this.dealerSettings?.claimOwnStockCarEnabled) {
      this.stockCar = await Configuration_Api.getStockcar(this.stockCarId)
    }

    this.isLoadingStatus = false

    if (this.reservation?.StatusIds?.DealerId) {
      this.isLoadingDealerIDS = true

      // DealerId is actually EstablishmentId, seems to be a bug in PCQM / IDS
      Dealer_API.getEstablishment(this.reservation.StatusIds.DealerId)
        .then((data) => {
          this.dealerIDS = data
        })
        .catch()
        .finally(() => {
          this.isLoadingDealerIDS = false
        })
    }
  },
  methods: {
    formatDate(value) {
      return value == null ? '' : moment(value).format('l')
    },
  },
}
</script>

<style lang="scss" scoped>
dl {
  display: grid;
  grid-template-columns: 8em auto;
  margin-bottom: 2em;
}

dt,
dd {
  padding: 0.5em 0;
  border-bottom: 1px solid #dae2e5;
}

dt {
  font-weight: $font-weight-bold;
  padding-right: 0.5em;
}

h2 {
  font-size: 1.25em;
}

.loader {
  margin: 0;
  width: 2.5em;
  height: 1.5em;
}
</style>
